import { Directive } from '@angular/core';
import { ValidatorFn, AbstractControl, FormGroup, FormControl } from '@angular/forms';

@Directive({
  selector: '[appPanNumberValidation]'
})
export class PanNumberValidationDirective {

  constructor() { }

}

export function panNumberValidator(form: FormGroup): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control && control.value) {
      let value: string = control.value;
      let specialChar = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
      if (!specialChar.test(value)) {
        if (value.length >= 3) {
          let stringRegex = new RegExp('^[A-Za-z ]*$');
          if (!stringRegex.test(value.substr(0, 3))) {
            return { 'pattern': { value: control.value } };
          } else {
            if (value.length >= 4) {
              let regExp = new RegExp('^[CPHFATBLJG]*$');
              if (!regExp.test(value.substr(3, 1))) {
                return { 'pattern': { value: control.value } };
              } else {
                if (value.length >= 5) {
                  let fName, mName, lName: RegExp;
                  let subValue = value.substr(4, 1).toLowerCase();

                  if (form.controls['firstName'].value) {
                    fName = new RegExp(form.controls['firstName'].value.charAt(0).toLowerCase());
                  }
                  if (form.controls['middleName'].value) {
                    mName = new RegExp(form.controls['middleName'].value.charAt(0).toLowerCase());
                  }
                  if (form.controls['lastName'].value) {
                    lName = new RegExp(form.controls['lastName'].value.charAt(0).toLowerCase());
                  }
                  if (fName) {
                    if (!fName.test(subValue)) {
                      if (mName) {
                        if (!mName.test(subValue)) {
                          if (lName) {
                            if (!lName.test(subValue)) {
                              return { 'pattern': { value: control.value } };
                            } else {
                              if (value.length >= 6) {
                                let numberRegex = new RegExp('^[0-9]*$');
                                if (!numberRegex.test((value.substr(5, 4)))) {
                                  return { 'pattern': { value: control.value } };
                                } else {
                                  if (value.length > 10 || value.length < 10) {
                                    return { 'pattern': {value: control.value} };
                                  } else {
                                    return null;
                                  }
                                }
                              } else {
                                return null;
                              }
                            }
                          }
                        } else {
                          if (value.length >= 6) {
                            let numberRegex = new RegExp('^[0-9]*$');
                            if (!numberRegex.test((value.substr(5, 4)))) {
                              return { 'pattern': { value: control.value } };
                            } else {
                              if (value.length > 10 || value.length < 10) {
                                return { 'pattern': {value: control.value} };
                              } else {
                                return null;
                              }
                            }
                          } else {
                            return null;
                          }
                        }
                      }
                    } else {
                      if (value.length >= 6) {
                        let numberRegex = new RegExp('^[0-9]*$');
                        if (!numberRegex.test((value.substr(5, 4)))) {
                          return { 'pattern': { value: control.value } };
                        } else {
                          if (value.length > 10 || value.length < 10) {
                            return { 'pattern': {value: control.value} };
                          } else {
                            return null;
                          }
                        }
                      } else {
                        return null;
                      }
                    }
                  } else if (mName) {
                    if (!mName.test(subValue)) {
                      if (lName) {
                        if (!lName.test(subValue)) {
                          return { 'pattern': { value: control.value } };
                        } else {
                          if (value.length >= 6) {
                            let numberRegex = new RegExp('^[0-9]*$');
                            if (!numberRegex.test((value.substr(5, 4)))) {
                              return { 'pattern': { value: control.value } };
                            } else {
                              if (value.length > 10 || value.length < 10) {
                                return { 'pattern': {value: control.value} };
                              } else {
                                return null;
                              }
                            }
                          } else {
                            return null;
                          }
                        }
                      }
                    } else {
                      if (value.length >= 6) {
                        let numberRegex = new RegExp('^[0-9]*$');
                        if (!numberRegex.test((value.substr(5, 4)))) {
                          return { 'pattern': { value: control.value } };
                        } else {
                          if (value.length > 10 || value.length < 10) {
                            return { 'pattern': {value: control.value} };
                          } else {
                            return null;
                          }
                        }
                      } else {
                        return null;
                      }
                    }
                  } else if (lName) {
                    if (!lName.test(subValue)) {
                      return { 'pattern': { value: control.value } };
                    } else {
                      if (value.length >= 6) {
                        let numberRegex = new RegExp('^[0-9]*$');
                        if (!numberRegex.test((value.substr(5, 4)))) {
                          return { 'pattern': { value: control.value } };
                        } else {
                          if (value.length > 10 || value.length < 10) {
                            return { 'pattern': {value: control.value} };
                          } else {
                            return null;
                          }
                        }
                      } else {
                        if (value.length >= 6) {
                          let numberRegex = new RegExp('^[0-9]*$');
                          if (!numberRegex.test((value.substr(5, 4)))) {
                            return { 'pattern': { value: control.value } };
                          } else {
                            if (value.length > 10 || value.length < 10) {
                              return { 'pattern': {value: control.value} };
                            } else {
                              return null;
                            }
                          }
                        } else {
                          return null;
                        }
                      }
                    }
                  } else {
                    if (value.length >= 6) {
                      let numberRegex = new RegExp('^[0-9]*$');
                      if (!numberRegex.test((value.substr(5, 4)))) {
                        return { 'pattern': { value: control.value } };
                      } else {
                        if (value.length > 10 || value.length < 10) {
                          return { 'pattern': {value: control.value} };
                        } else {
                          return null;
                        }
                      }
                    } else {
                      return null;
                    }
                  }
                } else {
                  if (value.length >= 6) {
                    let numberRegex = new RegExp('^[0-9]*$');
                    if (!numberRegex.test((value.substr(5, 4)))) {
                      return { 'pattern': { value: control.value } };
                    } else {
                      if (value.length > 10 || value.length < 10) {
                        return { 'pattern': {value: control.value} };
                      } else {
                        return null;
                      }
                    }
                  } else {
                    return null;
                  }
                }
              }
            } else {
              return null;
            }
          }
        } else {
          // return { 'panNumberValidation': {value: control.value} }
          return null;
        }
      } else {
        return { 'pattern': { value: control.value } };
      }
    }
  };
}

export function confirmPanValidation(form: FormGroup): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control && control.value && form) {
     let panNoValue = form.controls['panNumber'].value;
     if (panNoValue) {
      if (panNoValue !== control.value) {
        return { 'confirmPANValidation': { value: control.value } };
      } else {
        return null;
      }
     } else {
       return null;
     }
    } else {
      return null;
    }
  };
}
